import _axios from 'axios'

export const authTokenHeader = 'x-auth-token'

const authStages = ['int', 'cons'].includes(
  process.env.REACT_APP_ENVIRONMENT?.toLowerCase()
)

export const axios = _axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: authStages,
})

export const setAxiosToken = token => {
  if (token) {
    axios.defaults.headers.common[authTokenHeader] = token
  } else {
    delete axios.defaults.headers.common[authTokenHeader]
  }
}

export const getAxiosTokenFromQueryParam = () => {
  const queryParams = new URLSearchParams(window.location.search)
  return queryParams.get('token')
}

export const setAxiosTokenFromQueryParam = () => {
  const token = getAxiosTokenFromQueryParam()
  setAxiosToken(token)
}
